import { useState } from "react"

import { CheckCircleIcon } from "@chakra-ui/icons"

import DataTable from "../Common/DataTable"

const LocationList = ({ locations, setSelected }) => {
  const [selected, setChecked] = useState([])

  return (
    <DataTable
      rows={locations}
      columns={{
        name: { label: "Nome" },
        zone: { label: "Zona" },
        isRitiro: {
          label: "Punto di Ritiro",
          textAlign: "center",
          sort: false,
          render: (item) => (
            <CheckCircleIcon
              w={4}
              h={4}
              color={item.isRitiro ? "green.500" : "gray.200"}
              cursor="pointer"
            />
          ),
        },
        description: { label: "Dettagli" },
      }}
      selected={selected}
      setSelected={setChecked}
      onRowClick={(item) => setSelected(item)}
    />
  )
}

export default LocationList
